var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.auto-start",value:(_vm.tooltipData),expression:"tooltipData",modifiers:{"auto-start":true}}],class:[
    _vm.theme,
    _vm.size,
    'label-'+_vm.type
  ]},[(_vm.theme === 'marker-type')?_c('div',{staticClass:"icon",class:'icon-'+_vm.type}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }